import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useQueryClient} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {useRefraMutation} from '../../useRefraMutation'

import {mutations} from '@refra/api/mutations'
import {logger} from '@refra/modules/common/utils'

export const useEditComment = () => {
  const {t} = useTranslation()
  const queryClient = useQueryClient()

  return useRefraMutation({
    mutationFn: mutations.editComment,
    onError: (error) => {
      const errorDetails = error?.response?.data.detail ?? error.message ?? error.response?.status
      logger
        .context('useEditComment')
        .extras({errorDetails})
        .error('Error occurred while editing a comment')

      spawnErrorToast(t('error.editComment'))
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: ['comments']})
      spawnSuccessToast(t('success.editComment'))
    }
  })
}
